import { render, staticRenderFns } from "./ClientReportComplex2ParamForm.vue?vue&type=template&id=36758de5&scoped=true"
import script from "./ClientReportComplex2ParamForm.vue?vue&type=script&lang=js"
export * from "./ClientReportComplex2ParamForm.vue?vue&type=script&lang=js"
import style0 from "./ClientReportComplex2ParamForm.vue?vue&type=style&index=0&id=36758de5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36758de5",
  null
  
)

export default component.exports